/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop } from '@stencil/core';
import { Memoize, isEmpty, parseIfString } from '@springbokagency/stencil-base';
import { ColorVariant } from '../../../types/colors.types';
import type { EfbButton } from '../../atoms/button/button';

@Component({
  tag: 'efb-pack-card',
  styleUrl: 'pack-card.scss',
  shadow: true,
})
export class EfbPackCard {
  /**
   * Props
   */
  @Prop() productName: string;

  @Prop() assuranceType: string;

  @Prop() button: EfbButton | string;

  @Memoize('button')
  get parsedbutton(): EfbButton {
    return parseIfString(this.button);
  }

  @Prop() bottomText: string;

  @Prop() variant: ColorVariant;

  /**
   * Render
   */

  render() {
    return (
      <Host>
        <article class={`pack-card ${!isEmpty(this.variant) ? `is-${this.variant}` : ''}`}>
          {/* Product name */}
          <h3 class="product-name">{this.productName}</h3>

          {/* Assurance type */}
          <p class="assurance-type" innerHTML={this.assuranceType}></p>

          {/* Button */}
          <efb-button {...this.parsedbutton} variant={this.variant} whiteBg target="_blank" />

          {/* Bottom text */}
          <efb-paragraph class="bottom-text" text={this.bottomText} size="sm" />
        </article>
      </Host>
    );
  }
}
